import React, { useState, useEffect } from 'react';
import { ListGroup, Card, Form } from 'react-bootstrap';
const BusinessUnitSelector = _ref => {
  let {
    dashboardData,
    isMultipleSelectionEnabled,
    setIsMultipleSelectionEnabled,
    selectedBUDashboard,
    selectBusinessUnits,
    isAllSelected,
    setIsAllSelected
  } = _ref;
  const [filteredBusinessUnits, setFilteredBusinessUnits] = useState([]);
  const [businessUnits, setBusinessUnits] = useState([]);
  const handleBusinessUnitSearch = e => {
    const searchValue = e.target.value;
    if (searchValue) {
      const filteredBusinessUnits = businessUnits.filter(bu => bu?.toLowerCase().includes(searchValue?.toLowerCase()));
      setFilteredBusinessUnits(filteredBusinessUnits);
    } else {
      setFilteredBusinessUnits(businessUnits);
    }
  };
  useEffect(() => {
    if (!dashboardData || !selectedBUDashboard) return;
    const units = [...dashboardData.dashboard_by_business_unit.map(bu => bu.business_unit), 'all' // matches dashboard_without_business_unit.business_unit
    ];
    setFilteredBusinessUnits(units);
    setBusinessUnits(units);
  }, [dashboardData]);
  return /*#__PURE__*/React.createElement(Card, {
    className: "p-2 dashboard-business-unit-selector-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(Form.Control, {
    type: "text",
    className: "dashboard-business-unit-search mb-2 me-2",
    placeholder: "Search",
    onChange: handleBusinessUnitSearch
  }), /*#__PURE__*/React.createElement("span", {
    className: `material-icons mt-1 dashboard-business-unit-multiple-select 
          ${isMultipleSelectionEnabled ? 'dashboard-business-unit-multiple-select__active' : 'dashboard-business-unit-multiple-select__inactive'}`,
    onClick: () => setIsMultipleSelectionEnabled(!isMultipleSelectionEnabled)
  }, "checklist_rtl")), /*#__PURE__*/React.createElement(ListGroup, {
    defaultActiveKey: selectedBUDashboard[0].business_unit
  }, /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    active: isAllSelected,
    key: "all",
    action: true,
    onClick: () => setIsAllSelected(!isAllSelected)
  }, "All"), filteredBusinessUnits.map(businessUnit => /*#__PURE__*/React.createElement(ListGroup.Item, {
    className: "busines-unit-item mb-1",
    active: selectedBUDashboard.findIndex(bu => bu.business_unit === businessUnit) > -1,
    key: businessUnit ?? 'no-business-unit',
    action: true,
    onClick: () => selectBusinessUnits(businessUnit)
  }, businessUnit === 'all' ? 'No Business Unit' : businessUnit))));
};
export default BusinessUnitSelector;